import { render, staticRenderFns } from "./ModalContentVirtualMemberEdit.vue?vue&type=template&id=572d8c67&"
import script from "./ModalContentVirtualMemberEdit.vue?vue&type=script&lang=js&"
export * from "./ModalContentVirtualMemberEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentVirtualMemberEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports